__turbopack_context__.v({
  "container": "_40GhpW_container",
  "isBouncing": "_40GhpW_isBouncing",
});
